import {
  BaseLayerSchemas,
  BaseStyleId,
  mapSchema,
  MapSchema,
} from "@cartographerio/atlas-map";
import {
  MapCollaborationModel,
  MapPermissionModel,
} from "@cartographerio/types";
import { baseStyles as defaultBaseStyles } from "./baseStyles";
import {
  generatedMapCollaborationModel,
  generatedMapPermissionModel,
} from "./permissions.generated";

interface MapSchemaWithDefaultsProps
  extends Omit<
    MapSchema,
    | "type"
    | "permissionModel"
    | "collaborationModel"
    | "baseStyles"
    | "defaultBaseStyleId"
  > {
  baseStyles?: BaseLayerSchemas;
  defaultBaseStyleId?: BaseStyleId;
  collaborationModel?: MapCollaborationModel;
  permissionModel?: MapPermissionModel;
}

export function mapSchemaWithDefaults(
  props: MapSchemaWithDefaultsProps
): MapSchema {
  const {
    mapId,
    baseStyles = defaultBaseStyles,
    defaultBaseStyleId = "terrain",
    collaborationModel = generatedMapCollaborationModel(mapId),
    permissionModel = generatedMapPermissionModel(mapId),
    ...rest
  } = props;

  return mapSchema({
    mapId,
    baseStyles,
    defaultBaseStyleId,
    collaborationModel,
    permissionModel,
    ...rest,
  });
}
